// const AppHomePage = () => import(/* webpackChunkName: "online-home" */ '@/modules/online-home-page');
const AppBookingPage = () =>
    import(/* webpackChunkName: "online-booking" */ '@/modules/online/booking');
const AppServicesPage = () =>
    import(/* webpackChunkName: "online-services" */ '@/modules/online/services');
const AppDatePage = () => import(/* webpackChunkName: "online-date" */ '@/modules/online/date');
const AppConfirmPage = () =>
    import(/* webpackChunkName: "online-confirm" */ '@/modules/online/confirm');
const AppEmployeesPage = () =>
    import(/* webpackChunkName: "online-employees" */ '@/modules/online/employees/employees-list');
const AppReviewsPage = () =>
    import(
        /* webpackChunkName: "online-employees-reviews" */ '@/modules/online/employees/_id/employees-reviews-list'
    );

//SideBar
const AppSideBarOnline = () =>
    import(
        /* webpackChunkName: "side-bar-online" */ '@/components/layouts/side-bar/the-side-bar-online'
    );

/*
 *  Add noHeader in meta if you don't need header
 *  Add noStepBack in meta if you don't need arrow back
 * */

const meta = {
    layout: 'link',
    hideHeaderDescription: true,
    headerAddress: true,
};

export default [
    {
        path: '/online/:id',
        name: 'home-online',
        meta: {
            ...meta,
            title: 'Онлайн-запись',
            // noStepBack: true,
            back: 'home-box',
        },
        components: {
            default: AppBookingPage,
            sidebar: AppSideBarOnline,
        },
    },
    {
        path: '/online/:id/booking',
        name: 'booking',
        meta: {
            ...meta,
            title: 'Онлайн-запись',
            back: 'home-box',
        },
        components: {
            default: AppBookingPage,
            sidebar: AppSideBarOnline,
        },
    },
    {
        path: '/online/:id/employees',
        name: 'employees',
        meta: {
            ...meta,
            title: 'Выберите сотрудника',
            back: 'booking',
        },
        components: {
            default: AppEmployeesPage,
            sidebar: AppSideBarOnline,
        },
    },
    {
        path: '/online/:id/employees/:employeeID',
        name: 'employee-info',
        meta: {
            ...meta,
            title: 'О сотруднике',
            back: 'employees',
        },
        components: {
            default: AppReviewsPage,
            sidebar: AppSideBarOnline,
        },
    },
    {
        path: '/online/:id/services',
        name: 'services',
        meta: {
            ...meta,
            title: 'Выберите услуги',
            back: 'booking',
        },
        components: {
            default: AppServicesPage,
            sidebar: AppSideBarOnline,
        },
    },
    {
        path: '/online/:id/date',
        name: 'date',
        meta: {
            ...meta,
            title: 'Выберите дату и время',
            back: 'booking',
        },
        components: {
            default: AppDatePage,
            sidebar: AppSideBarOnline,
        },
    },
    {
        path: '/online/:id/confirm',
        name: 'confirm',
        meta: {
            ...meta,
            title: 'Подтверждение данных',
            back: 'booking',
        },
        components: {
            default: AppConfirmPage,
            sidebar: AppSideBarOnline,
        },
    },
    {
        path: '/online/:id/reviews',
        name: 'master-reviews',
        meta: {
            ...meta,
            title: 'Отзывы специалиста',
        },
        components: {
            default: AppReviewsPage,
            sidebar: AppSideBarOnline,
        },
    },
];
